export default __webpack_public_path__ + "static/media/background.ccbcd077.png";